import React from "react";

import ManageSubscriptionsView from "./ManageSubscriptionsView";

const ManageSubscriptions = () => {
  return <ManageSubscriptionsView />;
};

export default ManageSubscriptions;
